module.exports = __webpack_public_path__ + "img/logo.46a5b218.png";